<template>
    <div class="ku-location">
    </div>
</template>

<script>

    export default {
        name: "location",
        data() {
            return {}
        },
        methods: {
        },
        mounted() {
            this.$wx.wxJsSdkInit()
        }
    }
</script>

<style lang="less" scoped>
    .ku-location {
        height: 100%;
        width: 100%;
        position: fixed;
        background: #50AFA7;
    }
</style>
